import * as React from 'react';
import dynamic from 'next/dynamic';

/*
 * The SINGLE reachable entry point to Quick Actions.
 * --------------------------------------------------------------------------
 * When `enabled` (STAGE_ENV !== 'prod'), this lazily loads the non-prod-only
 * Quick Actions code as its own chunk. In production `enabled` is false, so the
 * dynamic import below is never invoked and the chunk is never fetched.
 *
 * This is the ONLY place allowed to pull in `apps/pro/quickActions/*`; the
 * `no-restricted-imports` ESLint rule bans STATIC imports of it everywhere
 * else. A dynamic `import()` like the one below is not a static import, so the
 * rule does not (and should not) flag it — it is the intended single entry.
 */
const QuickActions = dynamic(() => import('../quickActions'), { ssr: false });

export const QuickActionsGate: React.FC<{ enabled: boolean }> = ({ enabled }) => {
  if (!enabled) {
    return null;
  }
  return <QuickActions />;
};
